(function () {
  if (window.__P2P_NEXT_STEP_BOUND__) return;
  window.__P2P_NEXT_STEP_BOUND__ = true;

  const state = {};
  const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024; // 20 MB
  const ACCEPTED_EXTENSIONS = ['png', 'jpg', 'jpeg', 'heic', 'heif'];
  const ACCEPTED_MIME_TYPES = {
    'image/png': true,
    'image/jpg': true,
    'image/jpeg': true,
    'image/heic': true,
    'image/heif': true
  };

  const ctaConfigs = {
    print: {
      label: 'Continue',
      cls: 'p2p-next-step__cta p2p-next-step__cta--print is-ready',
      hint: 'Uploaded images auto delete after 24 hours. We do not store files.'
    },
    style: {
      label: 'Continue',
      cls: 'p2p-next-step__cta p2p-next-step__cta--style is-ready',
      hint: 'Uploaded images auto delete after 24 hours. We do not store files.'
    },
    edit: {
      label: 'Continue',
      cls: 'p2p-next-step__cta p2p-next-step__cta--edit is-ready',
      hint: 'Uploaded images auto delete after 24 hours. We do not store files.'
    }
  };

  function getSearchParams() {
    try {
      return new URLSearchParams(window.location.search || '');
    } catch (error) {
      return new URLSearchParams();
    }
  }

  function hasDataEntryFlag() {
    return getSearchParams().get('data') === 'true';
  }

  function redirectToStep1(root) {
    const redirectUrl = (root && root.dataset.step1RedirectUrl) || 'https://prompt2prints.com/pages/photo-to-canvas';
    window.location.replace(redirectUrl);
  }

  function getCookieValue(name) {
    if (!name || !document.cookie) return null;

    const parts = document.cookie.split('; ');
    for (let i = 0; i < parts.length; i += 1) {
      const entry = parts[i];
      const separatorIndex = entry.indexOf('=');
      const key = separatorIndex === -1 ? entry : entry.slice(0, separatorIndex);
      if (key === name) {
        const value = separatorIndex === -1 ? '' : entry.slice(separatorIndex + 1);
        try {
          return decodeURIComponent(value);
        } catch (error) {
          return value;
        }
      }
    }

    return null;
  }

  function setCookie(name, value, maxAgeSeconds) {
    if (!name) return;

    const cookieParts = [
      name + '=' + encodeURIComponent(value || ''),
      'path=/',
      'max-age=' + maxAgeSeconds,
      'SameSite=Lax'
    ];

    if (window.location && /(^|\.)prompt2prints\.com$/i.test(window.location.hostname)) {
      cookieParts.push('domain=.prompt2prints.com');
    }

    if (window.location && window.location.protocol === 'https:') {
      cookieParts.push('Secure');
    }

    document.cookie = cookieParts.join('; ');
  }

  function getStorageValue(key) {
    if (!key) return null;

    try {
      const value = localStorage.getItem(key);
      return value || null;
    } catch (error) {
      return null;
    }
  }

  function getStoredValueWithExpiry(key) {
    if (!key) return null;

    try {
      const rawValue = localStorage.getItem(key);
      if (!rawValue) return null;

      if (rawValue.charAt(0) === '{' && rawValue.indexOf('"expiry"') !== -1) {
        const parsedValue = JSON.parse(rawValue);
        if (parsedValue.expiry && Date.now() > parsedValue.expiry) {
          localStorage.removeItem(key);
          return null;
        }
        return parsedValue.value || null;
      }

      return rawValue;
    } catch (error) {
      return null;
    }
  }

  function getUploadedImageSource(root) {
    const primaryStorageKey = root.dataset.uploadedImageKey || 'pdpUploadedImage';
    const cookieKeys = [
      root.dataset.originalImageCookieKey || 'pdpOriginalImage',
      root.dataset.originalImageCookieAltKey || 'p2pOriginalImage',
      root.dataset.uploadedImageCookieKey,
      root.dataset.uploadedImageCookieAltKey,
      primaryStorageKey,
      'p2pUploadedImage'
    ].filter(Boolean);

    for (let i = 0; i < cookieKeys.length; i += 1) {
      const cookieValue = getCookieValue(cookieKeys[i]);
      if (cookieValue) return cookieValue;
    }

    const storageKeys = [
      root.dataset.originalImageKey || 'pdpOriginalImage',
      'pdpOriginalImage',
      primaryStorageKey,
      'pdpUploadedImage',
      'p2p_uploaded_image'
    ];

    for (let i = 0; i < storageKeys.length; i += 1) {
      const storageValue = getStorageValue(storageKeys[i]);
      if (storageValue) return storageValue;
    }

    return null;
  }

  function persistUploadedImage(root, cloudfrontLink) {
    const keys = [
      root.dataset.originalImageKey || 'pdpOriginalImage',
      root.dataset.originalImageCookieKey || 'pdpOriginalImage',
      root.dataset.originalImageCookieAltKey || 'p2pOriginalImage',
      root.dataset.uploadedImageKey || 'pdpUploadedImage',
      root.dataset.uploadedImageCookieKey || 'pdpUploadedImage',
      root.dataset.uploadedImageCookieAltKey || 'p2pUploadedImage'
    ].filter(Boolean);

    keys.forEach(function (key) {
      try {
        localStorage.setItem(key, cloudfrontLink);
      } catch (error) {}
      setCookie(key, cloudfrontLink, 24 * 60 * 60);
    });
  }

  function getPrompt2PrintsConfig() {
    const prompt2Prints = window.Prompt2Prints || {};
    return {
      apiBase: prompt2Prints.apiBase || 'https://api.prompt2prints.com',
      apiKey: prompt2Prints.apiKey || ''
    };
  }

  function getCustomerId(root) {
    return (root && root.dataset.customerId) || window.shopifyCustomerId || 'guest';
  }

  function getSessionId() {
    if (typeof window.getLocalStorage1Day === 'function') {
      return window.getLocalStorage1Day('sessionId') || 'none';
    }

    return getStoredValueWithExpiry('sessionId') || 'none';
  }

  function getFileExtension(fileName) {
    const match = (fileName || '').toLowerCase().match(/\.([a-z0-9]+)$/);
    return match ? match[1] : '';
  }

  function isHeicLike(file) {
    if (!file) return false;
    const extension = getFileExtension(file.name);
    const type = (file.type || '').toLowerCase();
    return extension === 'heic' || extension === 'heif' || type === 'image/heic' || type === 'image/heif';
  }

  function validateUploadFile(file) {
    if (!file) {
      return {
        valid: false,
        message: 'Please choose a file to continue.'
      };
    }

    const mimeType = (file.type || '').toLowerCase();
    const extension = getFileExtension(file.name);
    const isAcceptedType = !!ACCEPTED_MIME_TYPES[mimeType] ||
      ACCEPTED_EXTENSIONS.indexOf(extension) !== -1;

    if (!isAcceptedType) {
      return {
        valid: false,
        message: 'Only JPG, PNG or HEIC images are allowed.'
      };
    }

    if (file.size > MAX_FILE_SIZE_BYTES) {
      return {
        valid: false,
        message: 'Your image exceeds the 20 MB limit. Please upload a smaller file.'
      };
    }

    return {
      valid: true,
      isHeic: isHeicLike(file)
    };
  }

  function loadHeic2Any() {
    if (typeof window.heic2any === 'function') return Promise.resolve();
    if (window.__p2pHeic2anyPromise) return window.__p2pHeic2anyPromise;

    const existing = document.querySelector('script[data-heic2any]');
    if (existing) {
      window.__p2pHeic2anyPromise = new Promise(function (resolve, reject) {
        const timeoutId = window.setTimeout(function () {
          reject(new Error('HEIC converter load timed out.'));
        }, 15000);

        existing.addEventListener('load', function () {
          window.clearTimeout(timeoutId);
          resolve();
        });
        existing.addEventListener('error', function () {
          window.clearTimeout(timeoutId);
          reject(new Error('Failed to load HEIC converter.'));
        });
      });
      return window.__p2pHeic2anyPromise;
    }

    const cdnUrl =
      window.P2P_HEIC2ANY_CDN_URL ||
      'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';

    window.__p2pHeic2anyPromise = new Promise(function (resolve, reject) {
      const script = document.createElement('script');
      script.src = cdnUrl;
      script.async = true;
      script.defer = true;
      script.dataset.heic2any = 'true';

      const timeoutId = window.setTimeout(function () {
        script.remove();
        reject(new Error('HEIC converter load timed out.'));
      }, 15000);

      script.addEventListener('load', function () {
        window.clearTimeout(timeoutId);
        resolve();
      });
      script.addEventListener('error', function () {
        window.clearTimeout(timeoutId);
        reject(new Error('Failed to load HEIC converter.'));
      });

      document.head.appendChild(script);
    });

    return window.__p2pHeic2anyPromise;
  }

  function convertHeicToJpeg(file) {
    if (!isHeicLike(file)) return Promise.resolve(file);

    return loadHeic2Any().then(function () {
      if (typeof window.heic2any !== 'function') {
        throw new Error('HEIC conversion library (heic2any) not available.');
      }

      return window.heic2any({
        blob: file,
        toType: 'image/jpeg',
        quality: 0.92
      }).then(function (convertedBlob) {
        const blob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;
        const baseName = (file.name || 'upload.heic').replace(/\.(heic|heif)$/i, '');
        return new File([blob], baseName + '.jpg', { type: 'image/jpeg' });
      });
    });
  }

  function readFileAsDataUrl(file) {
    return new Promise(function (resolve, reject) {
      const reader = new FileReader();

      reader.onload = function (event) {
        resolve(event.target.result);
      };

      reader.onerror = function () {
        reject(new Error('Could not read the selected file.'));
      };

      reader.readAsDataURL(file);
    });
  }

  async function uploadImageToAPI(file, root) {
    const apiConfig = getPrompt2PrintsConfig();
    if (!apiConfig.apiKey) {
      throw new Error('Prompt2Prints API key is missing.');
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('customerId', getCustomerId(root));
    formData.append('sessionId', getSessionId());
    formData.append('megamenu', 'true');

    const response = await fetch(apiConfig.apiBase + '/upload-image', {
      method: 'POST',
      headers: {
        'x-api-key': apiConfig.apiKey
      },
      body: formData
    });

    if (!response.ok) {
      throw new Error('API Error: ' + response.status);
    }

    return response.json();
  }

  function updateStatus(el, message, isError) {
    if (!el) return;

    if (!message) {
      el.hidden = true;
      el.classList.remove('is-error');
      el.textContent = '';
      return;
    }

    el.hidden = false;
    if (isError) el.classList.add('is-error');
    else el.classList.remove('is-error');
    el.textContent = message;
  }

  function setCtaDisabledState(root, sectionId) {
    const els = getElements(root);
    const current = state[sectionId];
    if (!els.ctaBtn || !current) return;

    const shouldDisable = !current.selected || current.isUploadingImage;
    els.ctaBtn.disabled = shouldDisable;
    els.ctaBtn.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
  }

  function normalizeNavMode(mode) {
    if (mode === 'ai') return 'ai';
    if (mode === 'print') return 'print';
    if (mode === 'style') return 'style';
    if (mode === 'edit') return 'edit';
    return 'upload';
  }

  function setNavMode(mode) {
    const nav = document.getElementById('p2pNav');
    if (!nav) return;

    nav.dataset.navMode = normalizeNavMode(mode);
  }

  function getFlowChoiceKey(root) {
    return (root && root.dataset.flowChoiceKey) || 'p2p_flow_choice';
  }

  function persistFlowChoice(root, value) {
    const storageKey = getFlowChoiceKey(root);
    if (!storageKey || !value) return;

    try {
      localStorage.setItem(storageKey, value);
    } catch (error) {}
  }

  function getSavedFlowChoice(root) {
    const storageKey = getFlowChoiceKey(root);
    if (!storageKey) return null;

    const savedValue = getStorageValue(storageKey);
    if (savedValue === 'print' || savedValue === 'style' || savedValue === 'edit') {
      return savedValue;
    }

    return null;
  }

  function getRoot(sectionId) {
    return document.getElementById('next-step-' + sectionId);
  }

  function getElements(root) {
    return {
      previewImg: root.querySelector('#previewImg'),
      imageFrame: root.querySelector('#imageFrame'),
      imageLoading: root.querySelector('#imageLoading'),
      badgeText: root.querySelector('#badgeText'),
      uploadStatus: root.querySelector('#p2pUploadStatus'),
      changePhotoTrigger: root.querySelector('[data-change-photo]'),
      changePhotoInput: root.querySelector('#p2pChangePhotoInput'),
      ctaBtn: root.querySelector('#upload-selectoption'),
      ctaLabel: root.querySelector('#ctaLabel'),
      ctaHint: root.querySelector('#ctaHint'),
      stylePicker: root.querySelector('#stylePicker'),
      tweaksPanel: root.querySelector('#tweaksPanel')
    };
  }

  function setPreviewLoading(root, isLoading, message) {
    const els = getElements(root);
    if (els.imageFrame) {
      els.imageFrame.classList.toggle('is-loading', !!isLoading);
    }

    if (els.imageLoading && message) {
      const textNode = els.imageLoading.querySelector('.p2p-next-step__image-loading-text');
      if (textNode) {
        textNode.textContent = message;
      }
    }
  }

  function loadPreviewImage(root, imageSrc, altText, loadingMessage) {
    const els = getElements(root);
    if (!els.previewImg || !imageSrc) {
      setPreviewLoading(root, false);
      return Promise.resolve();
    }

    setPreviewLoading(root, true, loadingMessage || 'Loading your image...');

    return new Promise(function (resolve, reject) {
      function cleanup() {
        els.previewImg.removeEventListener('load', handleLoad);
        els.previewImg.removeEventListener('error', handleError);
      }

      function handleLoad() {
        cleanup();
        setPreviewLoading(root, false);
        resolve();
      }

      function handleError() {
        cleanup();
        setPreviewLoading(root, false);
        reject(new Error('Image failed to load.'));
      }

      els.previewImg.addEventListener('load', handleLoad);
      els.previewImg.addEventListener('error', handleError);

      if (altText) {
        els.previewImg.alt = altText;
      }

      els.previewImg.src = imageSrc;

      if (els.previewImg.complete && els.previewImg.naturalWidth > 0) {
        cleanup();
        setPreviewLoading(root, false);
        resolve();
      }
    });
  }

  function setupSection(root) {
    if (!root) return;
    const sectionId = root.dataset.sectionId;
    const els = getElements(root);

    state[sectionId] = {
      selected: null,
      selectedStyle: 'Aristocrat',
      isUploadingImage: false
    };

    const savedImg = getUploadedImageSource(root);
    setPreviewLoading(root, true, 'Loading your image...');

    if (savedImg && els.previewImg) {
      loadPreviewImage(root, savedImg, els.previewImg.alt, 'Loading your image...').catch(function (error) {
        console.error('Failed to load saved preview image:', error);
      });
    } else if (hasDataEntryFlag() && els.previewImg) {
      redirectToStep1(root);
      return;
    } else if (root.dataset.defaultImage && els.previewImg) {
      loadPreviewImage(root, root.dataset.defaultImage, els.previewImg.alt, 'Loading preview...').catch(function (error) {
        console.error('Failed to load default preview image:', error);
      });
    } else {
      setPreviewLoading(root, false);
    }

    const firstStyle = root.querySelector('.p2p-next-step__style-chip');
    if (firstStyle) {
      state[sectionId].selectedStyle = firstStyle.textContent.trim();
    }

    const savedChoice = getSavedFlowChoice(root);
    if (savedChoice) {
      state[sectionId].selected = savedChoice;
      updateSelectionUI(root, savedChoice, sectionId);
      return;
    }

    setNavMode(root.dataset.defaultNavMode || 'print');
    setCtaDisabledState(root, sectionId);
  }

  function bindChangePhoto(root, sectionId) {
    const els = getElements(root);
    if (!els.changePhotoTrigger || !els.changePhotoInput) return;

    els.changePhotoTrigger.addEventListener('click', function (event) {
      event.preventDefault();
      if (state[sectionId] && state[sectionId].isUploadingImage) return;

      updateStatus(els.uploadStatus, '');
      els.changePhotoInput.value = '';
      if (typeof els.changePhotoInput.showPicker === 'function') {
        els.changePhotoInput.showPicker();
      } else {
        els.changePhotoInput.click();
      }
    });

    els.changePhotoInput.addEventListener('change', async function () {
      const file = els.changePhotoInput.files && els.changePhotoInput.files[0];
      if (!file) return;

      const validation = validateUploadFile(file);
      if (!validation.valid) {
        els.changePhotoInput.value = '';
        updateStatus(els.uploadStatus, validation.message, true);
        return;
      }

      state[sectionId].isUploadingImage = true;
      els.changePhotoTrigger.classList.add('is-processing');
      setCtaDisabledState(root, sectionId);
      setPreviewLoading(root, true, validation.isHeic ? 'Converting and loading your image...' : 'Loading your image...');

      try {
        const processedFile = validation.isHeic ? await convertHeicToJpeg(file) : file;
        const previewDataUrl = await readFileAsDataUrl(processedFile);
        const data = await uploadImageToAPI(processedFile, root);

        if (!data || !data.cloudfrontLink) {
          throw new Error('cloudfrontLink not found in API response');
        }

        persistUploadedImage(root, data.cloudfrontLink);

        if (els.previewImg) {
          await loadPreviewImage(
            root,
            previewDataUrl,
            (processedFile.name || 'Uploaded photo') + ' preview',
            'Loading your image...'
          );
        }

        if (els.badgeText) {
          if (state[sectionId].selected === 'style') {
            els.badgeText.textContent = 'Original';
          } else if (state[sectionId].selected === 'edit') {
            els.badgeText.textContent = 'Original';
          } else {
            els.badgeText.textContent = 'Original';
          }
        }

      } catch (error) {
        console.error('Step 2 image change failed:', error);
      } finally {
        state[sectionId].isUploadingImage = false;
        els.changePhotoTrigger.classList.remove('is-processing');
        els.changePhotoInput.value = '';
        setPreviewLoading(root, false);
        setCtaDisabledState(root, sectionId);
      }
    });
  }

  function updateSelectionUI(root, type, sectionId) {
    const els = getElements(root);

    ['print', 'style', 'edit'].forEach(function (name) {
      const option = root.querySelector('#opt-' + name);
      if (option) option.classList.toggle('is-selected', name === type);
    });

    if (els.stylePicker) {
      els.stylePicker.classList.toggle('is-visible', type === 'style');
    }

    if (els.imageFrame) {
      els.imageFrame.classList.toggle('is-stylized', type === 'style');
    }

    if (els.badgeText) {
      if (type === 'print') els.badgeText.textContent = 'Original';
      if (type === 'style') els.badgeText.textContent = 'Original';
      if (type === 'edit') els.badgeText.textContent = 'Original';
    }

    const cfg = ctaConfigs[type];
    if (cfg && els.ctaBtn && els.ctaLabel && els.ctaHint) {
      els.ctaBtn.className = cfg.cls;
      els.ctaLabel.textContent = cfg.label;
      els.ctaHint.textContent = cfg.hint;
    }

    setNavMode(type);
    setCtaDisabledState(root, sectionId);
  }

  window.selectOpt = function (type, sectionId) {
    const root = getRoot(sectionId);
    if (!root || !state[sectionId]) return;

    state[sectionId].selected = type;
    persistFlowChoice(root, type);
    updateSelectionUI(root, type, sectionId);
  };

  window.pickStyle = function (button, styleName, sectionId) {
    const root = getRoot(sectionId);
    if (!root || !state[sectionId]) return;
    state[sectionId].selectedStyle = styleName;

    root.querySelectorAll('.p2p-next-step__style-chip').forEach(function (chip) {
      chip.classList.remove('is-active');
    });
    button.classList.add('is-active');

    if (state[sectionId].selected === 'style') {
      const badgeText = root.querySelector('#badgeText');
      if (badgeText) badgeText.textContent = styleName + ' style preview';
    }
  };

  window.handleContinue = function (sectionId) {
    const root = getRoot(sectionId);
    if (!root || !state[sectionId]) return;

    const current = state[sectionId];
    if (!current.selected || current.isUploadingImage) return;

    persistFlowChoice(root, current.selected);

    function buildNextUrl(baseStr) {
      try {
        var nextUrl = new URL(baseStr, window.location.origin);
        var currentParams = new URLSearchParams(window.location.search || '');
        currentParams.set('data', 'true');
        currentParams.forEach(function(value, key) {
          nextUrl.searchParams.set(key, value);
        });
        return nextUrl.toString();
      } catch(e) {
        return baseStr;
      }
    }

    if (current.selected === 'style') {
      // Save the selected style name so step3 can restore it
      try { localStorage.setItem(root.dataset.selectedStyleKey || 'p2p_selected_style', current.selectedStyle); } catch (e) {}

      // Re-persist the uploaded image so step3 can reliably read it from both
      // localStorage AND cookies regardless of which storage step1 wrote to
      var imgSrc = getUploadedImageSource(root);
      if (imgSrc) {
        persistUploadedImage(root, imgSrc);
      }

      var styleUrl = root.dataset.styleContinueUrl || 'https://prompt2prints.com/pages/photo-to-canvas-style?data=true';
      window.location.href = buildNextUrl(styleUrl);
      return;
    }

    if (current.selected === 'print') {
      // Clear any stale style selection from a previous session
      try { localStorage.removeItem(root.dataset.selectedStyleKey || 'p2p_selected_style'); } catch (e) {}

      var printUrl = root.dataset.printContinueUrl || 'https://prompt2prints.com/products/canvas?syncMode=pdp-img';
      window.location.href = buildNextUrl(printUrl);
      return;
    }

    if (current.selected === 'edit') {
      var originalImgSrc = getUploadedImageSource(root);
      if (originalImgSrc) {
        persistUploadedImage(root, originalImgSrc);
      }

      try { localStorage.removeItem(root.dataset.selectedStyleKey || 'p2p_selected_style'); } catch (e) {}
      try { localStorage.removeItem('pdpStylizedImage'); } catch (e) {}
      try { localStorage.removeItem('p2pStylizedImage'); } catch (e) {}
      try { localStorage.removeItem('pdpEditedImage'); } catch (e) {}

      var editUrl =
        root.dataset.editContinueUrl ||
        root.dataset.continueUrl ||
        'https://prompt2prints.com/pages/photo-to-canvas-edit?data=true';

      if (editUrl) {
        window.location.href = buildNextUrl(editUrl);
      }
      return;
    }

    // any future choice — use the generic continue URL
    try { localStorage.removeItem(root.dataset.selectedStyleKey || 'p2p_selected_style'); } catch (e) {}

    if (root.dataset.continueUrl) {
      window.location.href = buildNextUrl(root.dataset.continueUrl);
    }
  };

  window.closeTweaksPanel = function (sectionId) {
    const root = getRoot(sectionId);
    if (!root) return;
    const tweaksPanel = root.querySelector('#tweaksPanel');
    if (tweaksPanel) tweaksPanel.hidden = true;
    window.parent.postMessage({ type: '__edit_mode_dismissed' }, '*');
  };

  window.addEventListener('message', function (e) {
    document.querySelectorAll('.p2p-next-step').forEach(function (root) {
      const tweaksPanel = root.querySelector('#tweaksPanel');
      if (!tweaksPanel) return;
      if (e.data && e.data.type === '__activate_edit_mode') tweaksPanel.hidden = false;
      if (e.data && e.data.type === '__deactivate_edit_mode') tweaksPanel.hidden = true;
    });
  });

  const roots = document.querySelectorAll('.p2p-next-step');
  if (!roots.length) return;

  if (!hasDataEntryFlag()) {
    redirectToStep1(roots[0]);
    return;
  }

  roots.forEach(function (root) {
    setupSection(root);
    bindChangePhoto(root, root.dataset.sectionId);
    window.parent.postMessage({ type: '__edit_mode_available' }, '*');
  });
})();
